import "../../assets/scss/privacy-style.scss";
import React from "react";
import { useTranslation } from "react-i18next";

const TermsOfService: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="privacy">
      <div>
        <h2>{t("Terms of Service")}</h2>
        <p>{t("tos.lastUpdated")}</p>
      </div>

      <section>
        <h2>{t("tos.section1.title")}</h2>
        <p>{t("tos.section1.body")}</p>
      </section>

      <section>
        <h2>{t("tos.section2.title")}</h2>
        <p>{t("tos.section2.body")}</p>
      </section>

      <section>
        <h2>{t("tos.section3.title")}</h2>
        <ul>
          <li>{t("tos.section3.item1")}</li>
          <li>{t("tos.section3.item2")}</li>
          <li>{t("tos.section3.item3")}</li>
          <li>{t("tos.section3.item4")}</li>
        </ul>
      </section>

      <section>
        <h2>{t("tos.section4.title")}</h2>
        <p>{t("tos.section4.body")}</p>
      </section>

      <section>
        <h2>{t("tos.section5.title")}</h2>
        <p>{t("tos.section5.body")}</p>
      </section>

      <section>
        <h2>{t("tos.section6.title")}</h2>
        <p>{t("tos.section6.body")}</p>
      </section>

      <section>
        <h2>{t("tos.section7.title")}</h2>
        <p>{t("tos.section7.body")}</p>
      </section>

      <section>
        <h2>{t("tos.section8.title")}</h2>
        <p>{t("tos.section8.body")}</p>
      </section>

      <section>
        <h2>{t("tos.section9.title")}</h2>
        <p>
          {t("tos.section9.body")}{" "}
          <a href="mailto:info@neurowatt.ai">info@neurowatt.ai</a>
        </p>
      </section>
    </div>
  );
};

export default TermsOfService;
